import { render, staticRenderFns } from "./Testbuy.vue?vue&type=template&id=25b19800"
import script from "./Testbuy.vue?vue&type=script&lang=js"
export * from "./Testbuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports